module.exports = __webpack_public_path__ + "img/certification_icon.368d640b.png";